import TrustPilotLogo from './assets/TrustPilotLogo.svg?react';
import TrustPilotStars from './assets/TrustPilotStars.svg?react';

export const TrustPilotBadge = () => {
  return (
    <div className="mt-2xl flex w-full items-center justify-center">
      <div className="flex flex-wrap items-center gap-s text-m font-med no-underline">
        Excellent
        <div>
          <TrustPilotStars className="mr-s w-[100px]" />
          <TrustPilotLogo className="w-[100px]" />
        </div>
        <span className="text-xs">· 7,000+ reviews</span>
      </div>
    </div>
  );
};
